import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const PromoBanners = lazy(() => import("modules/promo-banners/PromoBanners"));
export default function PromoBannersPage() {
  return (
    <SuspenseWrapper>
      <PromoBanners />
    </SuspenseWrapper>
  );
}
